import { render, staticRenderFns } from "./orderCost.vue?vue&type=template&id=57052bb6&scoped=true"
import script from "./orderCost.vue?vue&type=script&lang=js"
export * from "./orderCost.vue?vue&type=script&lang=js"
import style0 from "./orderCost.vue?vue&type=style&index=0&id=57052bb6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57052bb6",
  null
  
)

export default component.exports